// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as UseWindowSize$Showside from "../hook/UseWindowSize.bs.js";
var getTouchX = function getTouchX(e) {
  return e.touches[0].pageX;
};
function useEdgeSwipeDetector(param) {
  var windowWidth = UseWindowSize$Showside.useWindowWidth(undefined, undefined, undefined, undefined);
  var lastDetectionTime = React.useRef(undefined);
  var touchStartX = React.useRef(undefined);
  var touchEndX = React.useRef(undefined);
  var didEdgeSwipe = function (param) {
    return Belt_Option.getWithDefault(Belt_Option.map(lastDetectionTime.current, function (t) {
      return Date.now() - t < 200.0;
    }), false);
  };
  React.useEffect(function () {
    var onTouchStart = function (e) {
      var x = getTouchX(e);
      touchStartX.current = x;
    };
    var onTouchMove = function (e) {
      var x = getTouchX(e);
      touchEndX.current = x;
    };
    var onTouchEnd = function (e) {
      var match = touchStartX.current;
      var match$1 = touchEndX.current;
      if (match !== undefined && match$1 !== undefined) {
        var leftEdgeSwipe = match < 20 && (match$1 - match | 0) > 20;
        var rightEdgeSwipe = (windowWidth - match | 0) < 20 && (match$1 - match | 0) < -20;
        if (leftEdgeSwipe || rightEdgeSwipe) {
          lastDetectionTime.current = Date.now();
        }
      }
      touchStartX.current = undefined;
    };
    document.addEventListener("touchstart", onTouchStart, true);
    document.addEventListener("touchmove", onTouchMove, true);
    document.addEventListener("touchend", onTouchEnd, true);
    return function (param) {
      document.removeEventListener("touchstart", onTouchStart, true);
      document.removeEventListener("touchmove", onTouchMove, true);
      document.removeEventListener("touchend", onTouchEnd, true);
    };
  }, []);
  return didEdgeSwipe;
}
function useEdgeSwipeDetectorImmediate(param) {
  var windowWidth = UseWindowSize$Showside.useWindowWidth(undefined, undefined, undefined, undefined);
  var match = React.useState(function () {
    return false;
  });
  var setDidEdgeSwipe = match[1];
  React.useEffect(function () {
    var onTouchStart = function (e) {
      var x = getTouchX(e);
      var isLeftEdge = x <= 20;
      var isRightEdge = (windowWidth - x | 0) <= 20;
      if (isLeftEdge || isRightEdge) {
        return Curry._1(setDidEdgeSwipe, function (param) {
          return true;
        });
      }
    };
    var onTouchEnd = function (e) {
      Curry._1(setDidEdgeSwipe, function (param) {
        return false;
      });
    };
    document.addEventListener("touchstart", onTouchStart, true);
    document.addEventListener("touchend", onTouchEnd, true);
    return function (param) {
      document.removeEventListener("touchstart", onTouchStart, true);
      document.removeEventListener("touchend", onTouchEnd, true);
    };
  }, []);
  return match[0];
}
var largestDistanceFromEdge = 20;
export { getTouchX, largestDistanceFromEdge, useEdgeSwipeDetector, useEdgeSwipeDetectorImmediate };
/* react Not a pure module */